import { lazy } from "react";

export function lazyRetry<T extends React.ComponentType<any>>(
  importFn: () => Promise<{ default: T }>
) {
  return lazy(() =>
    importFn().catch(() => {
      const key = "chunk_reload";
      const hasReloaded = sessionStorage.getItem(key);
      if (!hasReloaded) {
        sessionStorage.setItem(key, "true");
        window.location.reload();
        // Never resolves — page is reloading
        return new Promise<never>(() => {});
      }
      sessionStorage.removeItem(key);
      return importFn();
    })
  );
}
